@if (showForm()) {
  @if (selectedCart()) {
    <app-not-billable-form
      [selectedElement]="selectedCart().obj"
      [displayHeaders]="false"
      [standardForm]="false"
      [(minScore)]="minScore"
      [(numberOfWantedClients)]="numberOfWantedClients"
      [(availableClients)]="availableClients"
      [(rowData)]="rowData"
      [(clientsMessage)]="clientsMessage"
      [(displayOnlyFlags)]="displayOnlyFlags"
      [(isCollectibleApprovable)]="isCollectibleApprovable"
      [(clients)]="clients"
    />
  } @else {
    <div class="centered" style="height: 50px">
      <mat-progress-bar mode="indeterminate"/>
    </div>
  }

  @if (notBillableFormRef().isChanged()) {
    @if (rowData()) {
      <ag-grid-angular
        (resized)="conspicuityGridApi?.sizeColumnsToFit()"
        (gridReady)="conspicuityGridApi = $event.api"
        (firstDataRendered)="dynamicTooltipService.onFirstDataRendered($event)"
        (columnResized)="dynamicTooltipService.onColumnResized($event)"
        [domLayout]="'autoHeight'"
        [gridOptions]="gridOptions"
        [rowData]="rowData()"
        [columnDefs]="colDefs"
        class="ag-theme-alpine hide-header"
      />

      @if (isCollectibleApprovable()) {
        <div class="flex-row" style="flex-wrap: wrap; gap: 0.5rem; padding: 0.5rem">
          <button
            mat-raised-button
            color="accent"
            class="action-button"
            (click)="approveUncollectibleRequest()"
          >
            Antrag auf Uneinbringlichkeit genehmigen
          </button>

          <button
            mat-raised-button
            color="accent"
            class="action-button"
            (click)="declineUncollectibleRequest()"
          >
            Antrag auf Uneinbringlichkeit ablehnen
          </button>
        </div>
      }
    } @else {
      <div class="centered" style="height: 50px">
        <mat-progress-bar mode="indeterminate"/>
      </div>
    }


    @if (clientsMessage()) {
      <app-client-message-details
        [messageData]="clientsMessage()"
        [colDefs]="colDefs"
        (resolveAutomatically)="onResolveAutomatically()"
        (resolveManually)="onResolveManually()"
        (showDocument)="onShowDocument()"
      >
      </app-client-message-details>
    }
  } @else {
    <div class="centered" style="height: 50px">
      <mat-progress-bar mode="indeterminate"/>
    </div>
  }

  @if (selectedCart() && clients()?.length) {
    <div class="mat-h3">
      Patientenvergleich
      <div class="mat-caption">
        Es gibt Patienten mit ähnlichen Daten
      </div>
    </div>

    <app-clients-comparator-table
      style="flex: 1"
      [clients]="clients()"
      (takeData)="onTakeDataOfClient($event)"
      (getAnotherClient)="onGetAnotherClient($event)"
      (onSeparateClientReference)="separateClientReference()"
    />
  } @else {
    <div class="centered" style="height: 50px">
      <mat-progress-bar mode="indeterminate"/>
    </div>
  }
}

